import {systemConfiguration} from "../../../src/CommonImports";
import { useState } from "react";
import  './../css/GRecentJobs.css';
import  './../css/GBrowsebycategory.css';
import  './../css/GSideBar.css';
import  './../css/GPostJob.css';
import  './../css/GMediaQuery.css';
import  './../css/Gtop.css';
import  './../css/GAnimetion.css';
import  './../css/GGraphicJob.css';
import  './../css/GFooter.css';
import 'bootstrap/dist/css/bootstrap.min.css';


function GJobsHubMenu() {
    const [openMenu, setOpenMenu] = useState(null);
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    const toggleMenu = (menu) => {
      setOpenMenu(openMenu === menu ? null : menu);
    };

return (
<div className="offcanvas offcanvas-end" tabIndex="-1" id="rightSidebar" aria-labelledby="rightSidebarLabel">
  <div className="offcanvas-header">
    <h5 className="offcanvas-title" id="rightSidebarLabel">Menu</h5>
    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div className="offcanvas-body">
  
    <div className="user-account d-flex align-items-center border-bottom pb-2 mb-3">
      <img src="https://bootdey.com/img/Content/avatar/avatar7.png" alt="Avatar"/>
      <div>
        <h6 className="user-name mb-0">Deepak, <span className="text-primary">Moolya</span></h6>
        <p className="small text-muted mb-0">You have 2 new messages</p>
      </div>
    </div>

    <div className="p-3 border-bottom">
      <input type="text" className="form-control" placeholder="Search for items…" />
    </div>

   
    <nav className="sidebar-menu p-2">
      <div className="accordion" id="menuAccordion">

       
        <div className="accordion-item">
          <h2 className="accordion-header" id="homeHeading">
           <button
            className={`accordion-button ${openMenu === "home" ? "" : "collapsed"}`}
            onClick={() => toggleMenu("home")}
          >
            Home
          </button>
          </h2>
          <div className={`accordion-collapse collapse ${openMenu === "home" ? "show" : ""}`}>
            <div className="accordion-body p-2">
              <a href="/GHomePage1" className="nav-link">Home 1</a>
              <a href="#" className="nav-link">Home 2</a>
              <a href="#" className="nav-link">Home 3</a>
            </div>
          </div>
        </div>

       
        <div className="accordion-item">
          <h2 className="accordion-header" id="jobsHeading">
            <button  className={`accordion-button ${openMenu === "browseJobs" ? "" : "collapsed"}`} onClick={() => toggleMenu("browseJobs")}>
              Browse Jobs
            </button>
          </h2>
          <div className={`accordion-collapse collapse ${openMenu === "browseJobs" ? "show" : ""}`}>
            <div className="accordion-body p-2">
              <a href="#" className="nav-link">Job Grid</a>
              <a href="#" className="nav-link">Job Grid 2</a>
              <a href="#" className="nav-link">Job List</a>
              <hr/>
              <a href="/GJobSingle" className="nav-link">Job Single 01</a>
              <a href="#" className="nav-link">Job Single 02</a>
              <a href="#" className="nav-link">Job Single 03</a>
            </div>
          </div>
        </div>

       
        <div className="accordion-item">
          <h2 className="accordion-header" id="employersHeading">
            <button className={`accordion-button ${openMenu === "employers" ? "" : "collapsed"}`} onClick={() => toggleMenu("employers")}>
              Employers
            </button>
          </h2>
          <div className={`accordion-collapse collapse ${openMenu === "employers" ? "show" : ""}`}>
            <div className="accordion-body p-2">
              <a href="/" className="nav-link">Employers Grid</a>
              <a href="#" className="nav-link">Employers Grid 2</a>
              <a href="#" className="nav-link">Employers List</a>
              <hr/>
              <a href="/GEmployersSingle" className="nav-link">Employers Single 01</a>
              <a href="#" className="nav-link">Employers Single 02</a>
            </div>
          </div>
        </div>

       
        <div className="accordion-item">
          <h2 className="accordion-header" id="candidatesHeading">
            <button className={`accordion-button ${openMenu === "candidates" ? "" : "collapsed"}`} onClick={() => toggleMenu("candidates")}>
              Candidates
            </button>
          </h2>
          <div className={`accordion-collapse collapse ${openMenu === "candidates" ? "show" : ""}`}>
            <div className="accordion-body p-2">
              <a href="/GCandidatesgrid" className="nav-link">Candidates Grid</a>
              <a href="#" className="nav-link">Candidates Grid 2</a>
              <a href="#" className="nav-link">Candidates List</a>
              <hr/>
              <a href="/GCandidateSingle" className="nav-link">Candidates Single 01</a>
              <a href="/GCandidateSingle" className="nav-link">Candidates Single 02</a>
            </div>
          </div>
        </div>

       
        <div className="accordion-item">
          <h2 className="accordion-header" id="blogHeading">
            <button className={`accordion-button ${openMenu === "blog" ? "" : "collapsed"}`} onClick={() => toggleMenu("blog")}>
              Blog
            </button>
          </h2>
          <div className={`accordion-collapse collapse ${openMenu === "blog" ? "show" : ""}`}>
            <div className="accordion-body p-2">
              <a href="#" className="nav-link">Blog Grid</a>
              <a href="#" className="nav-link">Blog Grid Sidebar</a>
              <a href="#" className="nav-link">Blog List</a>
              <hr/>
              <a href="#" className="nav-link">Blog Single 01</a>
              <a href="#" className="nav-link">Blog Single 02</a>
            </div>
          </div>
        </div>

      
        <div className="accordion-item">
          <h2 className="accordion-header" id="pagesHeading">
            <button className={`accordion-button ${openMenu === "pages" ? "" : "collapsed"}`} onClick={() => toggleMenu("pages")}>
              Pages
            </button>
          </h2>
          <div  className={`accordion-collapse collapse ${openMenu === "pages" ? "show" : ""}`}>
            <div className="accordion-body p-2">
              <a href="/GJobAboutUs" className="nav-link">About Us</a>
              <a href="#" className="nav-link">Our Services</a>
              <a href="#" className="nav-link">Pricing Plan</a>
              <a href="#" className="nav-link">FAQs</a>
              <a href="/GJobContactUs" className="nav-link">Contact Us</a>
            </div>
          </div>
        </div>

      </div>
    </nav>
  </div>
</div>
)

}
export default GJobsHubMenu;